import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _extends from "@babel/runtime/helpers/esm/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
// This function is called when the user select an image
import { openEditor, createDefaultImageReader, createDefaultImageWriter, markup_editor_defaults, plugin_finetune_defaults, createDefaultShapePreprocessor, locale_en_gb, plugin_crop_locale_en_gb, plugin_finetune_locale_en_gb, plugin_annotate_locale_en_gb, markup_editor_locale_en_gb, plugin_annotate, plugin_crop, plugin_finetune, setPlugins } from "@pqina/pintura";
// This registers the plugins with Pintura Image Editor
setPlugins(plugin_crop, plugin_finetune, plugin_annotate);

// It opens the editor and returns the modified file when done
export var editImage = function editImage(image, done, _store, editorConfig, token, uploadUrl, isCircle) {
  var _editorConfig$quality;
  var imageFile = image.pintura ? image.pintura.file : image;
  var imageState = image.pintura ? image.pintura.data : {};
  var editor = openEditor(_extends({
    src: imageFile,
    imageState: imageState,
    imageReader: createDefaultImageReader(),
    imageWriter: createDefaultImageWriter(_extends({
      targetSize: editorConfig == null ? void 0 : editorConfig.targetSize,
      quality: (_editorConfig$quality = editorConfig == null ? void 0 : editorConfig.quality) != null ? _editorConfig$quality : 100
    }, _store && {
      store: function () {
        var _store2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(state) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", _store == null ? void 0 : _store.init(state, token, uploadUrl));
              case 1:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function store(_x) {
          return _store2.apply(this, arguments);
        }
        return store;
      }()
    }))
  }, (editorConfig == null ? void 0 : editorConfig.aspectRatio) && {
    imageCropAspectRatio: editorConfig.aspectRatio
  }, (editorConfig == null ? void 0 : editorConfig.imageCropMinSize) && {
    imageCropMinSize: editorConfig.imageCropMinSize
  }, (editorConfig == null ? void 0 : editorConfig.imageCropMaxSize) && {
    imageCropMaxSize: editorConfig.imageCropMaxSize
  }, markup_editor_defaults, plugin_finetune_defaults, {
    // This handles complex shapes like arrows / frames
    shapePreprocessor: createDefaultShapePreprocessor(),
    // This will set a square crop aspect ratio

    // Set locale
    locale: _extends({}, locale_en_gb, plugin_crop_locale_en_gb, plugin_finetune_locale_en_gb, plugin_annotate_locale_en_gb, markup_editor_locale_en_gb)
  }, (editorConfig == null ? void 0 : editorConfig.aspectRatio) === 1 && isCircle && {
    willRenderCanvas: function willRenderCanvas(shapes, state) {
      var utilVisibility = state.utilVisibility,
        selectionRect = state.selectionRect,
        lineColor = state.lineColor,
        backgroundColor = state.backgroundColor;

      // Exit if crop utils is not visible
      if (utilVisibility.crop <= 0) return shapes;

      // Get variable shortcuts to the crop selection rect
      var x = selectionRect.x,
        y = selectionRect.y,
        width = selectionRect.width,
        height = selectionRect.height;
      return _extends({}, shapes, {
        // Now we add an inverted ellipse shape to the interface shapes array
        interfaceShapes: [{
          x: x + width * 0.5,
          y: y + height * 0.5,
          rx: width * 0.5,
          ry: height * 0.5,
          opacity: utilVisibility.crop,
          inverted: true,
          backgroundColor: [].concat(_toConsumableArray(backgroundColor), [0.5]),
          strokeWidth: 1,
          strokeColor: _toConsumableArray(lineColor)
        }].concat(_toConsumableArray(shapes.interfaceShapes))
      });
    }
  }));
  editor.on("close", function () {
    // the user cancelled editing the image
  });

  // editor.on("loaderror", (data) => {
  //   console.log('data:', data);
  //   // editor.close();
  // });

  var addCloseButtonListener = function addCloseButtonListener() {
    var closeButton = document.querySelector('.PinturaStatusButton');
    if (closeButton) {
      closeButton.addEventListener('click', function () {
        return editor.close();
      });
    }
  };

  // Use MutationObserver to listen for changes and add event listener
  var observer = new MutationObserver(addCloseButtonListener);

  // Start observing the document for changes
  observer.observe(document, {
    childList: true,
    subtree: true
  });
  editor.on("process", function (_ref) {
    var dest = _ref.dest,
      imageState = _ref.imageState,
      src = _ref.src,
      store = _ref.store;
    var result = Object.assign(dest, {
      pintura: {
        dest: dest,
        imageState: imageState,
        src: src,
        store: store
      }
    });
    done(result);
  });
};